import index from './index.vue';

export default [
  {
    path: '/about',
    name: 'About',
    component: index,
  },
];
